// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  async getOrgCarrierSettings({}, orgId) {
    const response = await axios.get(`carrier/org-carrier-settings/${orgId}`);
    return response.data?.data || {};
  }
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  name: 'Warehouses',
  state,
  getters,
  actions,
  mutations
};
